import React from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Infographic from '../Infographic/Infographic';

function Section3({ touch }) {
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/3-tips-for-home-buyers-purchasing-with-friends-family',
      copy: 'not without complications and risks',
      label: 'Visit Highlights From the Profile of Home Buyers and Sellers'
    }
  ];
  return (
    <section className="sections">
      <h2 className="sections-title">The More the Merrier</h2>
      <p className="sections-copy">
        For millennials—the largest share of first-time homebuyers—living with roommates is a common
        experience. It may not be a surprise, then, that many are actually buying homes with
        roommates. According to the 2022 Home Buyers and Sellers Report, a full 5% of first-time
        buyers bought a home with individuals with whom they were not romantically involved. That is
        another all-time high since NAR started tracking the data. Instead of paying rent together,
        roommates can build equity together. The draw of buying with a friend may not be limited to
        sharing costs. The joys of homeownership can also be shared—not to mention the lawn mowing
        and dishes. It’s worth noting that buying a home with friends is{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} />, so it’s important to have the right mortgage
        broker and to work with an agent who is a REALTOR®, a member of the National Association of
        Realtors. It’s also critical to consult with a legal professional to ensure that there are
        clear lines of ownership. If your roommate gets a job in another state—or develops an
        allergy to your beloved cat—it’s important to have a plan in place.
      </p>
      <div className="sections__float">
        <Infographic touch={touch} />
        <p className="sections-copy">
          Other homebuyers were opting for different roommates: mom and dad. (Or even grandma and
          grandpa!) Across the board, 14% of home buyers were buying with family members for the
          purpose of establishing multigenerational homes. Lautz notes that an increasing number of
          people are opting to buy with aging parents or grandparents so that they can provide care
          for them—or get help caring for young children. Others are buying homes with their adult
          children who are finding it advantageous to move back home with their parents after
          college. Another factor, beyond caregiving and companionship, is the pooling of resources.
          Together, the multigenerational buyers can afford a home in a more desirable neighborhood
          or town which might have been off the table for an individual or a couple alone.
        </p>
      </div>
    </section>
  );
}

export default Section3;
